import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const messages = {
    'en': {
        update: 'Update',
        addToCart: 'Add to cart',
        checkout: 'Checkout',
        shoppingCart: 'Shopping cart',
        paymentMethod: 'Payment method',
        personalDetails: 'Personal details',
        orderNow: 'Order now',
        total: 'Total',
        errorTitle: 'Oops...',
        close: 'Close',
        thankYouTitle: 'Thanks for your order',
        thankYouFailTitle: 'Oops..',
        thankYouDescription: 'Download your tickets below',
        thankYouFailDescription: 'Er is iets fout gegaan',
        downloadTitle: 'Download your ticket',
        selectBank: 'Select bank',
        soldOut: 'Sold out',
        transactionCosts: 'Transaction fee',
        errorMessage: 'This field is required',
        coupon: 'Discount code',
        discount: 'Discount',
        invalidCode: 'Invalid discount code'
    },
    'nl': {
        update: 'Bijwerken',
        addToCart: 'Voeg toe aan winkelmand',
        checkout: 'Betalen',
        shoppingCart: 'Winkelmand',
        paymentMethod: 'Betalingsmethode',
        personalDetails: 'Persoonlijke gegevens',
        orderNow: 'Bestel nu',
        total: 'Totaal',
        errorTitle: 'Oops...',
        close: 'Sluiten',
        thankYouTitle: 'Bedankt voor je bestelling',
        thankYouFailTitle: 'Oops..',
        thankYouDescription: 'Download jouw tickets met de button hieronder.',
        thankYouFailDescription: 'Er is iets fout gegaan',
        downloadTitle: 'Download jouw ticket',
        selectBank: 'Kies uw bank',
        soldOut: 'Uitverkocht',
        transactionCosts: 'Transactiekosten',
        errorMessage: 'Dit veld is verplicht',
        coupon: 'Kortingscode',
        discount: 'Korting',
        invalidCode: 'Ongeldige kortingscode'
    }
};

export default new VueI18n({
    locale: (document.documentElement.lang || 'en-EN').slice(0, 2),
    fallbackLocale: 'nl',
    messages
});
